import * as React from 'react';

export const When = ({ condition, children }: { condition: unknown; children: React.ReactNode }) =>
  condition ? <>{children}</> : null;
